import {Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Platform, PopoverController} from '@ionic/angular';
import {BaseItem, DeviceTypeItem} from '../../../services/common-datatypes';
import {RestDataService} from '../../../services/rest-data.service';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {AdjustPopover} from '../../../decorators/adjust-popover.decorator';
import {AutoUnsubscribe} from '../../../decorators/common.decorators';


@Component({
    selector: 'app-category-select-popover',
    templateUrl: './category-select-popover.component.html',
    styleUrls: ['./category-select-popover.component.scss']
})
@AdjustPopover('elementRef', 'itemListElem')
export class CategorySelectPopoverComponent implements OnInit, OnDestroy {
    @ViewChild('itemList', {read: ElementRef}) itemListElem!: ElementRef;

    public canUsePartial = false;
    public selectedCategory: DeviceTypeItem = new DeviceTypeItem();
    public categoryList: DeviceTypeItem[] = [];
    public categorySearchControl!: FormControl;
    public categorySearch: string = '';
    public topName: string = '';

    private activeCategory!: DeviceTypeItem;

    // noinspection JSMismatchedCollectionQueryUpdate
    @AutoUnsubscribe('ngOnDestroy')
    private subscriptions: Subscription[] = [];

    constructor(private renderer: Renderer2,
                private elementRef: ElementRef,
                private platform: Platform,
                private dataService: RestDataService,
                private popoverCtrl: PopoverController) {

        this.categorySearchControl = new FormControl();
        this.categorySearch = '';
    }

    ngOnInit() {
        this.activeCategory = new DeviceTypeItem();
        this.activeCategory.updateFromJson(this.selectedCategory);
        this.resetListItems(this.getDepth() - 1);
        this.getCategories();
        this.subscriptions.push(this.categorySearchControl.valueChanges
            .pipe(
                debounceTime(150),
                distinctUntilChanged()
            ).subscribe((value: string) => {
                this.categorySearch = value;
                this.getCategories();
            })
        );
    }

    ngOnDestroy(): void {
    }

    public getDepth() {
        if ((BaseItem.UNDEFINED_ID !== this.activeCategory.cat_3_id) && (0 !== Number(this.activeCategory.cat_3_id))) {
            return 4;
        } else if ((BaseItem.UNDEFINED_ID !== this.activeCategory.cat_2_id) && (0 !== Number(this.activeCategory.cat_2_id))) {
            return 3;
        } else if ((BaseItem.UNDEFINED_ID !== this.activeCategory.cat_1_id) && (0 !== Number(this.activeCategory.cat_1_id))) {
            return 2;
        } else if ((BaseItem.UNDEFINED_ID !== this.activeCategory.cat_0_id) && (0 !== Number(this.activeCategory.cat_0_id))) {
            return 1;
        }
        return 0;
    }

    resetListItems(depth: number) {
        if (0 >= depth) {
            this.activeCategory.cat_0_id = BaseItem.UNDEFINED_ID;
            this.activeCategory.cat_0 = '';
        }
        if (1 >= depth) {
            this.activeCategory.cat_1_id = BaseItem.UNDEFINED_ID;
            this.activeCategory.cat_1 = '';
        }
        if (2 >= depth) {
            this.activeCategory.cat_2_id = BaseItem.UNDEFINED_ID;
            this.activeCategory.cat_2 = '';
        }
        if (3 >= depth) {
            this.activeCategory.cat_3_id = BaseItem.UNDEFINED_ID;
            this.activeCategory.cat_3 = '';
        }
    }

    getCategories() {
        this.dataService.getCategories(this.activeCategory['cat_0_id'], this.activeCategory['cat_1_id'],
            this.activeCategory['cat_2_id'], this.activeCategory['cat_3_id'], this.categorySearch)
            .then((data: DeviceTypeItem[]) => {
//                if ((0 === data.length) && (0 < this.getDepth())) {
//                    this.resetListItems(this.getDepth() - 1);
//                    this.getCategories();
//                } else {
                // Note: category list holds json objects, not initialized DeviceTypeItems
                this.categoryList = data;
                this.topName = this.getTopName();
//                }
            });
    }

    public getName(item: DeviceTypeItem): string {
        switch (this.getDepth()) {
            case 0:
                return item.cat_0;
            case 1:
                return item.cat_1;
            case 2:
                return item.cat_2;
            case 3:
                return item.cat_3;
            default:
                return 'invalid depth in getName: ' + this.getDepth();
        }
    }

    public getTopName(): string {
        switch (this.getDepth()) {
            case 0:
                return '';
            case 1:
                return this.activeCategory.cat_0;
            case 2:
                return this.activeCategory.cat_0 + ', ' + this.activeCategory.cat_1;
            case 3:
                return this.activeCategory.cat_0 + ', ' + this.activeCategory.cat_1 + ', ' + this.activeCategory.cat_2;
        }
        return '';
    }

    public selectNextCat(value: DeviceTypeItem) {
        this.selectedCategory.reset();
        this.activeCategory.updateFromJson(value);
        this.getCategories();
    }

    public selectPrevCat() {
        if (this.getDepth() > 0) {
            this.resetListItems(this.getDepth() - 1);
            this.getCategories();
        }
    }

    public selectCat(value: DeviceTypeItem) {
        if (this.canUsePartial || value.children === 0) {
            this.selectedCategory.reset();
            this.selectedCategory.updateFromJson(value);
            this.close();
        } else {
            this.selectNextCat(value);
        }
    }

    async close() {
        await this.popoverCtrl.dismiss(this.selectedCategory);
    }
}
